import { createFileRoute } from '@tanstack/react-router'
import HomePage from '@/components/pages/HomePage/HomePage'

export const Route = createFileRoute('/')({
  component: IndexRoute,
})

function IndexRoute() {
  return <HomePage />
}
